<template>
  <div class="ts-bg-gray-200 ts-border-blue-500 ts-p-3">
    <div class="ts-grid ts-grid-cols-2 ts-gap-2">
      <div>
        <label>{{ $t('saleContract.kads') }}</label>
        <input v-model.trim="model.kads" type="text" class="form-control" />
      </div>
      <div>
        <label class="required">{{ $t('saleContract.status') }}</label>
        <a-select
          v-model.number="model.sc_status_id"
          class="ts-w-full"
          :options="statusList"
        ></a-select>
        <div class="validate" v-if="errors.has('sc_status_id')">
          {{ errors.first('sc_status_id') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
export default {
  name: 'status',
  props: ['value', 'validate'],
  data () {
    return {
      errors: new Errors(),
      model: {}
    }
  },
  created () {
    this.model = this.value
  },
  computed: {
    ...mapState('wholesale/saleContract', ['quotations', 'formViewData']),
    statusList () {
      if (this.formViewData.status) {
        return this.formViewData.status.map(el => ({
          value: el.sc_status_id,
          label: el.sc_status
        }))
      }
      return []
    }
  },
  watch: {
    validate: function (error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
